import { render, staticRenderFns } from "./loanItem.vue?vue&type=template&id=3648df93&scoped=true&"
import script from "./loanItem.vue?vue&type=script&lang=js&"
export * from "./loanItem.vue?vue&type=script&lang=js&"
import style0 from "./loanItem.vue?vue&type=style&index=0&id=3648df93&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3648df93",
  null
  
)

export default component.exports